import { render, staticRenderFns } from "./BannerMessages.vue?vue&type=template&id=14734961"
import script from "./BannerMessages.vue?vue&type=script&lang=ts"
export * from "./BannerMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports